import { FileModel, IFile } from './file.model';
import { IPrefillValue, PrefillValueModel } from './prefill-value.model';

export interface IPrefill {
  prefillId: string;
  templateId: string;
  name: string;
  fileId: string | null;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  image?: IFile | null;
  values?: IPrefillValue[];
}

export class PrefillModel {
  prefillId: string;
  templateId: string;
  name: string;
  fileId: string | null;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;
  image: FileModel | null;
  values: PrefillValueModel[];

  constructor(data: IPrefill) {
    this.prefillId = data.prefillId;
    this.templateId = data.templateId;
    this.name = data.name;
    this.fileId = data.fileId ?? null;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.image = data.image ? new FileModel(data.image) : null;
    this.values = (data.values ?? []).map((value) => new PrefillValueModel(value));
  }
}
